import { render, staticRenderFns } from "./QuotaChip.vue?vue&type=template&id=2e632dd7"
import script from "./QuotaChip.vue?vue&type=script&lang=ts"
export * from "./QuotaChip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports